import TableEditViewState from '../store/schema/TableEditViewState';
import { IPoint } from 'office-ui-fabric-react/lib/utilities/positioning';
import { action } from 'satcheljs/lib/legacy';

export default action('setTableEditMenuViewState')(function setTableEditMenuViewState(
    viewState: TableEditViewState,
    position: IPoint,
    hasHeaders: boolean
) {
    viewState.position = position;
    viewState.hasHeaders = hasHeaders;
});
